// Pages
import Home from '../pages/Home'
import Profile from '../pages/Auth/Profile'

import Material from '../pages/Material'
import MaterialAdd from '../pages/Material/add'
import MaterialUpdate from '../pages/Material/update'

import Joint from '../pages/Joint'
import JointAdd from '../pages/Joint/add'
import JointUpdate from '../pages/Joint/update'

import Limit from '../pages/Limit'

import User from '../pages/User'
import UserAdd from '../pages/User/add'
import UserUpdate from '../pages/User/update'

import Role from '../pages/Role'
import RoleAdd from '../pages/Role/add'
import RoleUpdate from '../pages/Role/update'

import Pattern from '../pages/Pattern'
import PatternAdd from '../pages/Pattern/add'
import PatternUpdate from '../pages/Pattern/update'


import SeamlessTexture from '../pages/SeamlessTexture'
import SeamlessTextureAdd from '../pages/SeamlessTexture/add'
import SeamlessTextureUpdate from '../pages/SeamlessTexture/update'

import Brand from '../pages/Brand'
import BrandAdd from '../pages/Brand/add'
import BrandUpdate from '../pages/Brand/update'

// Utils
import useUserStore from '../utils/state/useUserStore'

const AllRoutes = () => {
  const userPermissions = useUserStore((state) => state.user) || []

  const Routes = [
    { path: '/', element: <Home />, permission: null },
    { path: '/profile', element: <Profile />, permission: null },
    { path: '/material', element: <Material />, permission: 'material:read' },
    { path: '/pattern', element: <Pattern />, permission: 'pattern:read' },
    {
      path: '/pattern/add',
      element: <PatternAdd />,
      permission: 'pattern:create',
    },
    {
      path: '/pattern/update/:id',
      element: <PatternUpdate />,
      permission: 'pattern:update',
    },
    {
      path: '/material/add',
      element: <MaterialAdd />,
      permission: 'material:create',
    },
    {
      path: '/material/update/:id',
      element: <MaterialUpdate />,
      permission: 'material:update',
    },
    { path: '/joint', element: <Joint />, permission: 'joint:read' },
    {
      path: '/joint/update/:id',
      element: <JointUpdate />,
      permission: 'joint:update',
    },
    { path: '/joint/add', element: <JointAdd />, permission: 'joint:create' },
    {
      path: '/seamless-texture',
      element: <SeamlessTexture />,
      permission: 'seamless-texture:read'
    },
    {
      path: '/seamless-texture/add',
      element: <SeamlessTextureAdd />,
      permission: 'seamless-texture:create',
    },
    {
      path: '/seamless-texture/update/:id',
      element: <SeamlessTextureUpdate />,
      permission: 'seamless-texture:update',
    },
    {
      path: '/brand',
      element: <Brand />,
      permission: 'brand:read'
    },
    {
      path: '/brand/add',
      element: <BrandAdd />,
      permission: 'brand:create'
    },
    {
      path: '/brand/update/:id',
      element: <BrandUpdate />,
      permission: 'brand:update'
    },
    { path: '/user', element: <User />, permission: 'user:read' },
    { path: '/user/add', element: <UserAdd />, permission: 'user:create' },
    { path: '/user/:id', element: <UserUpdate />, permission: 'user:update' },
    { path: '/role', element: <Role />, permission: 'role:read' },
    { path: '/role/add', element: <RoleAdd />, permission: 'role:create' },
    { path: '/role/:id', element: <RoleUpdate />, permission: 'role:update' },
    { path: '/limit', element: <Limit />, permission: 'limit:read' },
  ].filter(
    (route) =>
      !route.permission || userPermissions?.includes(route?.permission),
  )

  return Routes
}

export default AllRoutes
